import React from "react"

export default function CheckMarkInCircleIcon({
  className,
  width,
  height,
  color,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill={color ? color : "#B9B9B9"}
        fillRule="evenodd"
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm5.38 8.378l-.7-.714-6.13 6.008-3.153-3.002-.69.725 3.853 3.668 6.82-6.685z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
